import React from 'react';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  className?: string;
}
export function SectionHeading({
  title,
  subtitle,
  centered = false,
  className = ''
}: SectionHeadingProps) {
  return <div className={`mb-12 ${centered ? 'text-center' : ''} ${className}`} data-id="element-76">
      <h2 className="text-2xl md:text-3xl font-display font-semibold text-navy-dark mb-3" data-id="element-77">
        {title}
      </h2>
      {subtitle && <p className="text-navy max-w-2xl" data-id="element-78">{subtitle}</p>}
    </div>;
}